import { render, staticRenderFns } from "./productInfoStyle.vue?vue&type=template&id=db2e001e&scoped=true"
import script from "./productInfoStyle.vue?vue&type=script&lang=js"
export * from "./productInfoStyle.vue?vue&type=script&lang=js"
import style0 from "./productInfoStyle.vue?vue&type=style&index=0&id=db2e001e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2e001e",
  null
  
)

export default component.exports